<button mat-icon-button class="labeled-actions-buttons" (click)="makeIdle()">
    <mat-icon matTooltip="Make Idle">
        restore
    </mat-icon>
    <span>Make Idle</span>
</button>
